import FeatureAccessManager from './FeatureAccessManager'
export default FeatureAccessManager
